import { Request } from './Request';
import { IResult } from '../types/IResponse';
import { SelfServiceSchedule } from '../types/SelfServiceSchedule';


export interface SetExtractTasksSelfServiceScheduleRequestParams {
    schedule: SelfServiceSchedule;
    scheduleName: string;
    ids: number[];
}

export class SetExtractTasksSelfServiceScheduleRequest extends Request<SetExtractTasksSelfServiceScheduleRequestParams, IResult> {
    constructor(params: SetExtractTasksSelfServiceScheduleRequestParams) {
        super('setExtractTasksSelfServiceSchedule', params);
    }
}